import React, { useCallback, useState } from 'react';
import TreeItem from '../TreeItem/TreeItem';
import styles from './TreeBranch.module.scss';

function TreeBranch({ object, level = 0, allData }) {
  const [opened, setOpened] = useState(false);
  const onOpen = useCallback(() => setOpened((opened) => !opened), []);
  return (
    <>
      <TreeItem
        allData={allData}
        checkboxShown={object.canBeChecked}
        onSelect={object.onSelectChange}
        onOpen={onOpen}
        opened={opened}
        expandable={!!object.children?.length}
        object={object}
      />
      {opened &&
        object &&
        object?.children?.map((child, index) => {
          return (
            <div key={index} className={styles.step}>
              <TreeBranch
                allData={allData}
                onSelect={child.onSelectChange}
                level={level + 1}
                object={child}
              />
            </div>
          );
        })}
    </>
  );
}

export default TreeBranch;
